import {RegionModel} from './RegionModel';
import {LocalCustomerModel} from './LocalCustomerModel';
import {ResourcesUnitModel} from './ResourcesUnitModel';
import {ContractTypeModel} from './ContractTypeModel';
import {ProviderModel} from './ProviderModel';
import {DesignServicesModel} from './DesignServicesModel';
import {UnitsModel} from './UnitsModel';

export class DeltaVolumiModel {

  id: number;
  numAnnoMese: number;
  numAnnoMeseRif: number;
  region: RegionModel;
  localCustomer: LocalCustomerModel;
  resourceUnit: ResourcesUnitModel;
  designServices: DesignServicesModel;
  units: UnitsModel;
  delta: number;
  contractType: ContractTypeModel;
  actualMonthVol: number;
  previusMonthVol: number;
  expectedVol: number;
  isDeltaSignificativo: number;
  isClaims: number;
  note: string;
  isRecovery: number;
  provider: ProviderModel;
  monthlyForecastQuantity: number;


  constructor(id?: number,
              numAnnoMeseRif?: number,
              region?: RegionModel,
              localCustomer?: LocalCustomerModel,
              resourceUnit?: ResourcesUnitModel,
              sl1?: DesignServicesModel,
              units?: UnitsModel,
              delta?: number,
              contractType?: ContractTypeModel,
              actualMonthVol?: number,
              previusMonthVol?: number,
              expectedVol?: number,
              note?: string,
              isRecovery?: number,
              provider?: ProviderModel,
              monthlyForecastQuantity?: number) {
    this.id = id;
    this.numAnnoMeseRif = numAnnoMeseRif;
    this.region = region;
    this.localCustomer = localCustomer;
    this.resourceUnit = resourceUnit;
    this.designServices = sl1;
    this.units = units;
    this.delta = delta;
    this.contractType = contractType;
    this.actualMonthVol = actualMonthVol;
    this.previusMonthVol = previusMonthVol;
    this.expectedVol = expectedVol;
    this.note = note;
    this.isRecovery = isRecovery;
    this.provider = provider;
    this.monthlyForecastQuantity = monthlyForecastQuantity;
  }
}
